/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Prev_Next_DescInputs */

const en_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle previous and next event view`)
};

const fr_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer la vue de l'événement précédent et suivant`)
};

const de_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht des vorherigen/nächsten Ereignisses umschalten`)
};

const it_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la visualizzazione dell'evento precedente e successivo`)
};

const ru_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключиться между просмотром предыдущего и следующего события`)
};

const es_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar vista de evento anterior y siguiente`)
};

const zh_cn2_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换上一个和下一个事件视图`)
};

const ja_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントと次のイベントの表示を切り替える`)
};

const hi_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले और अगले इवेंट व्यू को टॉगल करें`)
};

const pt_pt2_toggle_prev_next_desc = /** @type {(inputs: Toggle_Prev_Next_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar visualização do evento anterior e seguinte`)
};

/**
* | output |
* | --- |
* | "Toggle previous and next event view" |
*
* @param {Toggle_Prev_Next_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_prev_next_desc = /** @type {((inputs?: Toggle_Prev_Next_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Prev_Next_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toggle_prev_next_desc(inputs)
	if (locale === "de") return de_toggle_prev_next_desc(inputs)
	if (locale === "it") return it_toggle_prev_next_desc(inputs)
	if (locale === "ru") return ru_toggle_prev_next_desc(inputs)
	if (locale === "es") return es_toggle_prev_next_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_toggle_prev_next_desc(inputs)
	if (locale === "ja") return ja_toggle_prev_next_desc(inputs)
	if (locale === "hi") return hi_toggle_prev_next_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_toggle_prev_next_desc(inputs)
	return en_toggle_prev_next_desc(inputs)
});